import trapFocus from './trap-focus';

/**
 * Product Share
 * @param {object} opts
 */
function productShare(opts) {
  const config = {
    dom: {
      button: 'js-product-share',
      modal: 'productShareModal',
      product: 'product',
    },
  };
  const c = __.extend(config, opts);

  // global elements
  const $product = document.getElementById(c.dom.product);
  const $shareButton = $product?.querySelector(`.${c.dom.button}`);
  let shareModal;

  /**
   * Init
   */
  function init() {
    if (!$shareButton) return;
    initShareModal();
    addEvents();
  }

  /**
   * Add Events
   */
  function addEvents() {
    __.addEvent({
      id: $shareButton,
      event: 'click',
      fn: handleShareBtnClick,
    });
  }

  /**
   * Handle Share Click
   */
  function handleShareBtnClick() {
    const {
      navigatorTitle,
      navigatorText,
      navigatorUrl,
    } = $shareButton.dataset;

    const shareConfig = {
      title: navigatorTitle,
      text: navigatorText,
      url: navigatorUrl,
    };

    if (typeof navigator?.canShare !== 'undefined' && navigator.canShare(shareConfig)) {
      navigator.share(shareConfig);
    } else {
      openShareModal();
    }
  }

  /**
   * Init Share Modal
   */
  function initShareModal() {
    const modalConfig = {
      dom: {
        modal_id: c.dom.modal,
        trigger: false,
      },
    };

    shareModal = SDG.Modal.init(modalConfig);
    shareModal?.init();
  }

  /**
   * Open Share Modal
   */
  function openShareModal() {
    if (!shareModal) return;
    shareModal.open();
    trapFocus(shareModal.element);
  }

  return init();
}

export default productShare;
